import { render, staticRenderFns } from "./ServiceCodeContradictoryAddEdit.vue?vue&type=template&id=e963b88c"
import script from "./ServiceCodeContradictoryAddEdit.vue?vue&type=script&lang=js"
export * from "./ServiceCodeContradictoryAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports